import { useQuery } from '@tanstack/react-query'
import { useMemo } from 'react'
import { Link } from 'react-router-dom'

import { obtenerFuentes, type Fuente } from '../api/consultas'

// El usuario lee en espanol e ingles. Las fuentes de MangaDex existen en
// decenas de idiomas y llenarian la pantalla de ruido.
const IDIOMAS = ['es', 'es-419', 'en', 'all']

const NOMBRE_IDIOMA: Record<string, string> = {
  es: 'Espanol',
  'es-419': 'Espanol (LatAm)',
  en: 'Ingles',
  all: 'Multiidioma',
}

export default function Explorar() {
  const { data, isLoading, error } = useQuery({
    queryKey: ['fuentes'],
    queryFn: obtenerFuentes,
  })

  const porIdioma = useMemo(() => {
    if (!data) return []
    const grupos = new Map<string, Fuente[]>()
    for (const fuente of data) {
      if (!IDIOMAS.includes(fuente.lang)) continue
      const lista = grupos.get(fuente.lang) ?? []
      lista.push(fuente)
      grupos.set(fuente.lang, lista)
    }
    return IDIOMAS.filter((i) => grupos.has(i)).map((idioma) => ({
      idioma,
      fuentes: grupos.get(idioma)!.sort((a, b) => a.name.localeCompare(b.name)),
    }))
  }, [data])

  return (
    <>
      <h1>Explorar</h1>
      <p className="subtitulo">Busca y anade series desde tus fuentes</p>

      {isLoading && <p className="cargando">Cargando fuentes…</p>}

      {error && (
        <div className="aviso error">
          <strong>No se pudieron cargar las fuentes</strong>
          <p>{(error as Error).message}</p>
        </div>
      )}

      {porIdioma.map(({ idioma, fuentes }) => (
        <section key={idioma}>
          <h2 style={{ fontSize: 15, margin: '22px 0 4px', color: 'var(--texto-tenue)' }}>
            {NOMBRE_IDIOMA[idioma] ?? idioma}
          </h2>
          <ul className="lista">
            {fuentes.map((fuente) => (
              <li key={fuente.id}>
                <Link to={`/fuente/${fuente.id}`}>
                  <span>{fuente.name}</span>
                  <span className="etiqueta-idioma">{fuente.lang}</span>
                </Link>
              </li>
            ))}
          </ul>
        </section>
      ))}
    </>
  )
}
